import React from 'react'
import { Row, Column, Body, Spacer } from '../components'

const PrivacyPolicyPage = () => {
	return <Column>Privacy policy
			  <Row>
				<Column desktopSize={1}></Column>
				<Column desktopSize={3}></Column>
				<Column desktopSize={7}>
					<Spacer />
					<h1>Privacy Policy</h1>
				{/* 	<Body>
						Download as a <a href="./pdf.com">PDF</a>
					</Body> */}
					<Spacer s />
				</Column>
				<Column desktopSize={1}></Column>
			 </Row>
			 <Row>
			 <Column desktopSize={1}></Column>
				<Column desktopSize={3}></Column>
				  <Column desktopSize={7}>
					<Spacer s />
					<h3>In General</h3>
					<Body paragraph>
					Beacon Secure Technologies is a provider of digital health testing solutions, offering a proprietary platform for employee healthcare monitoring and management.  
					We are committed to acting in accordance with GDPR 
					<ul>
						<li>Company means Beacon Secure Technologies Limited whose registered address is 20-22 WENLOCK ROAD, LONDON, ENGLAND, N1 7G</li>
						<li>GDPR means the General Data Protection Regulation</li>
						<li>Responsible Person means the person responsible for data protection within the Company</li>
						<li>Register of Systems means a register of all systems or contexts in which personal data is processed by the Company</li>
					</ul>
					</Body>
					<Spacer s />
					<h3>Data protection principles</h3>
					<Body paragraph>
					The Company is committed to processing data in accordance with its responsibilities under the GDPR. 

					<ol>
						<li>Article 5 of the GDPR requires that personal data shall be:</li>
						<ol>
							<li>processed lawfully, fairly and in a transparent manner in relation to individuals.</li>
							<li>collected for specified, explicit and legitimate purposes and not further processed in a manner that is incompatible with those purposes; further processing for archiving purposes in the public interest, scientific or historical research purposes or statistical purposes shall not be considered to be incompatible with the initial purposes;</li>
							<li>adequate, relevant and limited to what is necessary in relation to the purposes for which they are processed;</li>
							<li>accurate and, where necessary, kept up to date; every reasonable step must be taken to ensure that personal data that are inaccurate, having regard to the purposes for which they are processed, are erased or rectified without delay;</li>
							<li>kept in a form which permits identification of data subjects for no longer than is necessary for the purposes for which the personal data are processed; personal data may be stored for longer periods insofar as the personal data will be processed solely for archiving purposes in the public interest, scientific or historical research purposes or statistical purposes subject to implementation of the appropriate technical and organisational measures required by the GDPR in order to safeguard the rights and freedoms of individuals; and</li>
							<li>processed in a manner that ensures appropriate security of the personal data, including protection against unauthorised or unlawful processing and against accidental loss, destruction or damage, using appropriate technical or organisational measures.”</li>
						</ol>
						<li>General Provisionns</li>
						<ol>
							<li>This policy applies to all personal data processed by the Company. </li>
							<li>The Responsible Person shall take responsibility for the Company’s ongoing compliance with this policy. </li>
							<li>This policy shall be reviewed at least annually. </li>
							<li>The Company shall register with the Information Commissioner’s Office as an organisation that processes personal data. </li>
						</ol>
						<li>Lawful, fair and transparent processing</li>
						<ol>
							<li>To ensure its processing of data is lawful, fair and transparent, the Company shall maintain a Register of Systems. </li>
							<li>The Register of Systems shall be reviewed at least annually. </li>
							<li>Individuals have the right to access their personal data and any such requests made to the company shall be dealt with in a timely manner. </li>
						</ol>
						<li>Lawful purposes</li>
						<ol>
							<li>All data processed by the company must be done on one of the following lawful bases: consent, contract, legal obligation, vital interests, public task or legitimate interests (see ICO guidance for more information). </li>
							<li>The Company shall note the appropriate lawful basis in the Register of Systems.</li>
							<li>Where consent is relied upon as a lawful basis for processing data, evidence of opt-in consent shall be kept with the personal data.</li>
							<li>Where communications are sent to individuals based on their consent, the option for the individual to revoke their consent should be clearly available and systems should be in place to ensure such revocation is reflected accurately in the Company’s systems. </li>
						</ol>

						<li>Data minimisation</li>
						<ol>
						<li>The Company shall ensure that personal data are adequate, relevant and limited to what is necessary in relation to the purposes for which they are processed. </li>
						</ol>
						<li>Accuracy</li>
						<ol>
						<li>The Company shall take reasonable steps to ensure personal data is accurate. </li>
						<li>Where necessary for the lawful basis on which data is processed, steps shall be put in place to ensure that personal data is kept up to date. </li>
						</ol>
						<li>Archiving / removal</li>
						<ol>
							<li>To ensure that personal data is kept for no longer than necessary, the Company shall put in place an archiving policy for each area in which personal data is processed and review this process annually. </li>
							<li>The archiving policy shall consider what data should/must be retained, for how long, and why.</li>
						</ol>
						<li>Security</li>
						<ol>
							<li>The Company shall ensure that personal data is stored securely using modern software that is kept-up-to-date. </li>
							<li>Access to personal data shall be limited to personnel who need access and appropriate security should be in place to avoid unauthorised sharing of information. </li>
							<li>When personal data is deleted this should be done safely such that the data is irrecoverable.</li>
							<li>Appropriate back-up and disaster recovery solutions shall be in place. </li>
						</ol>
					<li>Breach</li>
					<br/>
					In the event of a breach of security leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, personal data, the Company shall promptly assess the risk to people’s rights and freedoms and if appropriate report this breach to the ICO (more information on the ICO website). 
					</ol>
					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>

					<Spacer s />
					<h3></h3>
					<Body paragraph>

					</Body>


				   </Column>
			 </Row>
	       </Column>
}

export { PrivacyPolicyPage }
